export const STORAGE_KEY = "french_elegant_vocab_app_v5_split";
export const DETAIL_CONTEXT_KEY = "detail_context_v5";
export const LANDMARK_UNLOCK_PREFIX = "landmark_unlock_v5_";
export const ENTRANCE_ANIMATION_SHOWN_KEY = "entrance_animation_shown_v5";